function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "10.901%",
  y1: "0%",
  x2: "89.099%",
  y2: "100%",
  id: "BPJS_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8CEF57",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#51B750",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "10.718%",
  y1: "0%",
  x2: "89.282%",
  y2: "100%",
  id: "BPJS_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0FFB7",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AEF3AD",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "62.243%",
  y1: "174.323%",
  x2: "62.243%",
  y2: "0%",
  id: "BPJS_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B4EC51",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#429321",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "118.974%",
  y1: "220.256%",
  x2: "-61.877%",
  y2: "-273.869%",
  id: "BPJS_svg__f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8F87D",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7ECE7D",
  offset: "100%"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-18.2%",
  y: "-39.3%",
  width: "136.4%",
  height: "178.5%",
  filterUnits: "objectBoundingBox",
  id: "BPJS_svg__c"
}, /*#__PURE__*/React.createElement("feOffset", {
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.21 0 0 0 0 0.7 0 0 0 0 0.495833333 0 0 0 0.4 0",
  "in": "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.972 8.445h.893c.407 0 .703.059.887.176.183.118.275.306.275.562 0 .175-.04.318-.12.43a.481.481 0 01-.321.201v.02c.182.042.313.119.393.232.08.113.121.263.121.451 0 .266-.095.474-.284.623-.189.15-.446.224-.77.224H3.972v-2.92zM4.581 9.6h.353c.165 0 .284-.026.358-.078.074-.052.111-.138.111-.258 0-.112-.04-.192-.12-.24-.081-.049-.208-.073-.382-.073h-.32V9.6zm0 .49v.762h.396c.168 0 .291-.033.371-.098.08-.065.12-.165.12-.3 0-.242-.17-.363-.51-.363H4.58zm2.7-.273h.2c.188 0 .328-.037.42-.112.094-.076.14-.185.14-.329 0-.145-.039-.252-.117-.321-.077-.07-.2-.104-.366-.104h-.276v.866zm1.375-.463c0 .314-.097.555-.29.72-.193.167-.467.25-.823.25h-.261v1.039h-.609v-2.92h.917c.348 0 .613.077.794.23.181.152.272.379.272.681zm.241 2.867a1.31 1.31 0 01-.36-.044v-.515c.106.027.201.04.287.04.134 0 .23-.042.287-.127.058-.084.086-.216.086-.396V8.445h.609v2.731c0 .34-.077.6-.23.779-.153.178-.38.267-.679.267zm3.325-1.669a.76.76 0 01-.28.623c-.186.152-.445.228-.778.228-.306 0-.577-.059-.812-.176v-.575c.193.088.357.15.491.186.134.036.257.054.368.054a.517.517 0 00.308-.078c.07-.052.107-.13.107-.232a.259.259 0 00-.048-.153.53.53 0 00-.138-.128l-.033-.021a4.051 4.051 0 00-.297-.157l-.042-.02a1.758 1.758 0 01-.394-.242.905.905 0 01-.21-.27.78.78 0 01-.079-.359c0-.258.086-.46.258-.609.172-.147.41-.221.714-.221.149 0 .291.018.427.054.135.036.277.086.424.151l-.196.482a2.839 2.839 0 00-.38-.134 1.203 1.203 0 00-.295-.038c-.115 0-.204.027-.265.082a.272.272 0 00-.092.213c0 .055.012.103.037.143.025.04.064.08.119.118.05.035.166.097.346.185l.04.02c.268.13.452.26.551.392.1.131.15.292.15.482z",
  id: "BPJS_svg__d"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.225 2.498l6.64-1.365c.203-.042.414-.042.618 0l6.639 1.365a1.534 1.534 0 011.225 1.503v7.704a6.82 6.82 0 01-4.338 6.352l-3.835 1.499-3.836-1.499A6.82 6.82 0 010 11.705V4c0-.728.512-1.356 1.225-1.503z",
  fill: "url(#BPJS_svg__a)",
  transform: "translate(1.222 1.222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.034 4.553l4.838-.993c.149-.03.302-.03.45 0l4.838.993c.522.106.896.565.896 1.097v5.583a4.979 4.979 0 01-3.171 4.639l-2.788 1.086-2.787-1.086a4.979 4.979 0 01-3.171-4.639V5.65c0-.532.374-.99.895-1.097z",
  fill: "url(#BPJS_svg__b)",
  transform: "translate(1.222 1.222)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.222 1.222)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#BPJS_svg__c)",
  xlinkHref: "#BPJS_svg__d"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#BPJS_svg__e)",
  xlinkHref: "#BPJS_svg__d"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.458 1.222)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#BPJS_svg__f)",
  width: 9.319,
  height: 9.319,
  rx: 1.55
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.456 3.41c.296 0 .527.113.694.342.167.228.25.545.25.95 0 .268-.038.5-.117.697a.976.976 0 01-.334.45.857.857 0 01-.51.154c-.294 0-.525-.107-.692-.32H5.71l.025.224c.006.066.01.11.01.131V7.06h-.682V3.456h.555l.097.325h.03c.16-.248.397-.372.71-.372zm-3.41-.724c.444 0 .773.081.987.243.213.162.32.408.32.738a.868.868 0 01-.16.513c-.105.15-.255.268-.449.353l.74 1.1.222.325h-.77l-.78-1.255h-.37v1.255h-.694V2.686h.954zm3.191 1.27c-.169 0-.292.051-.37.155-.061.083-.1.209-.114.378l-.006.136v.073c0 .269.04.461.12.578.08.116.206.174.379.174.306 0 .459-.252.459-.756 0-.246-.038-.43-.113-.554-.076-.123-.194-.185-.355-.185zm-3.24-.701h-.21v.884h.223c.22 0 .381-.037.486-.11.104-.073.156-.188.156-.344 0-.156-.053-.266-.16-.332-.106-.065-.272-.098-.496-.098z",
  fill: "#FFF"
})));

function SvgBpjs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgBpjs;